import React from 'react'
import { Pie } from 'react-chartjs-2';
import {Button, Card, CardBody, CardTitle, Col, Row} from "reactstrap";
import { CSVLink } from "react-csv";

const ChartPie = ( {
   title = '',
   data,
   onClick = ()=>console.info('Without action')
} )  => {
    const options = {
        responsive : true,
        plugins: {
            legend: {position: 'top'},
            title: {
                display: true,
                text: `${title}`
            },
            datalabels: {
                display: true,
                color: 'black',
                font: {
                    size: 12,
                    weight:'bold'
                }
            }
        },
    }

    return <Pie
        data={ data }
        options={ options }
        onClick={ onClick }
    />

}

const CardChartPie = ({ title, rawData, headers, graphicData, exportCSV = true  }) => <div className={'form-container'}>
    <div className={''}>
        <h2>{title}</h2>
        {
            exportCSV && <div className="float-right">
                <CSVLink
                    data={rawData}
                    headers={headers}
                    filename={`${title}.csv`}
                >
                    <Button
                        outline color="primary"
                        size="sm"
                        className="btn-cancel ml-2"
                    >
                        <i className="fa-solid fa-download"/>CSV
                    </Button>
                </CSVLink>
            </div>
        }
    </div>
    <div className={''}>
        <Row>
            <ChartPie title={''} data={graphicData} width={600} height={250}/>
        </Row>
    </div>
</div>

export {
    ChartPie as default,
    CardChartPie
}
